import { useEffect } from 'react';
import { useNavigation } from '@react-navigation/native';
import { ROUTE_NAMES } from './routes.constants';
import { TNavigation, TRouteComponent } from './routes.types';

export const Redirect: TRouteComponent<{ redirectRouteName: ROUTE_NAMES }> = ({ redirectRouteName, route }) => {
  const navigation = useNavigation<TNavigation>();
  useEffect(() => {
    navigation.navigate(redirectRouteName, route.params);
  }, []);
  return <></>;
};
